/**
 * Filters an array of table columns based on user permissions.
 *
 * Returns only those columns that either do not require a specific permission
 * or for which the user has the required permission.
 *
 * @param {Array<Object>} columns - The array of column configuration objects to filter.
 * @param {Array<string>} permissions - The list of permissions granted to the user.
 * @returns {Array<Object>} The filtered array of columns the user is allowed to access.
 *
 * @example
 * const columns = [
 *   { accessorKey: 'name', header: 'Name' },
 *   { accessorKey: 'delete', header: 'Delete', requiredPermission: 'REMOVE_MESHBOTS' }
 * ];
 * const permissions = ['REMOVE_MESHBOTS'];
 * const filtered = filterColumnsByPermissions(columns, permissions);
 * // Result: both columns will be present in filtered.
 */
export const filterColumnsByPermissions = (columns, permissions) => {
    return columns.filter((column) => {
        if (column.requiredPermission) {
            return permissions.includes(column.requiredPermission);
        }

        return true;
    });
};
